import { render, staticRenderFns } from "./EvolveNYDisclosure.vue?vue&type=template&id=20ceed80&"
import script from "./EvolveNYDisclosure.vue?vue&type=script&lang=js&"
export * from "./EvolveNYDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports